import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IPaginationOptions } from '@app/lib/pagination/interfaces';
import { PAGINATION_STATE_KEY } from '../pagination.constants';
import * as paginationState from './pagination.reducer';

export const paginationSelector = createFeatureSelector<IPaginationOptions>(PAGINATION_STATE_KEY);

export const maxPages = createSelector(
  paginationSelector,
  paginationState.maxPages,
);

export const perPage = createSelector(
  paginationSelector,
  paginationState.perPage,
);
